import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  dismiss: {
    id: 'react-components.irMoe1',
    defaultMessage: 'Dismiss message',
  },
});
